var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "settings-row"
  }, [_c('div', {
    staticClass: "settings-row__description"
  }, [_vm.title ? _c('h6', {
    staticClass: "settings-row__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.description ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._t("description")], 2), _c('div', {
    staticClass: "settings-row__control"
  }, [_vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }